import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M6.11 3.682a1 1 0 0 0-1 1v13.654H5a1 1 0 0 0-1 1v.982h11.892v-.982a1 1 0 0 0-.671-.945V8.341c.139.03.278.078.403.151.283.165.55.484.55 1.166v7.219c0 .317.096.768.371 1.152.29.402.765.71 1.459.71 1.375 0 1.996-1.082 1.996-1.829V7.196a.4.4 0 0 0-.117-.282l-2.777-2.777a.7.7 0 0 0-.046.974l.08.09 2.062 2.16v9.55c0 .383-.338 1.03-1.198 1.03-.424 0-.663-.174-.81-.378a1.25 1.25 0 0 1-.221-.686V9.658c0-.941-.398-1.537-.947-1.856a2.2 2.2 0 0 0-.806-.27v-2.85a1 1 0 0 0-1-1zm.124 1.578h7.863v4.493H6.234z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-gas"}) } }